/**
 * Expose all configurations under the ~/ts/config namespace
 */

export * from "@courses-models/course/src/ts/config/urls";
